module.exports = __webpack_public_path__ + "static/img/long_lx_blue.8b96bc57.svg";